import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

// import { flat } from "@utils";
import { protectedRoutes } from "app/routes";

import GullLayout from "app/layouts/GullLayout";
import AccessDenied from "app/views/sessions/AccessDenied";
import { hasAgencyAccess, isAgencyRoute } from "app/utils/agencyAccess";
import { hasRequiredRole } from "app/auth/authRoles";

const userHasPermission = (pathname, user, routes) => {
  if (!user) {
    return false;
  }

  const matched = routes.find((r) => r.path === pathname);
  if (!matched) return true;

  if (!matched.auth || !matched.auth.length) return true;

  return hasRequiredRole(user, matched.auth);
};

export default function AuthGuard() {

  const { pathname } = useLocation();
  const [previousRoute, setPreviousRoute] = useState(null);
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const agencyAllowed = !isAgencyRoute(pathname) || hasAgencyAccess(user);
  const hasPermission = userHasPermission(pathname, user, protectedRoutes) && agencyAllowed;

  useEffect(() => {
    if (previousRoute !== null) setPreviousRoute(pathname);
  }, [pathname, previousRoute]);

  return (
    <>
      {isAuthenticated && hasPermission ? (
        <GullLayout>
          <Outlet />
        </GullLayout>
      ) : (
        <>
          {isAuthenticated && !hasPermission ? (
            <AccessDenied />
          ) : (
            <Navigate to={previousRoute || "/sessions/signin"} replace={true} />
          )}
        </>
      )}
    </>
  );
}
